import { enforce, create, test, only } from 'vest';

function validarCuit(cuit) {
    const clean = String(cuit).replace(/[-\s]/g, '');
    if (!/^\d{11}$/.test(clean)) { return false; }
    const multiplicadores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    const suma = multiplicadores.reduce((acc, mult, i) => acc + parseInt(clean[i]) * mult, 0);
    const resto = suma % 11;
    const digitoVerificador = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;
    return digitoVerificador === parseInt(clean[10]);
}

export default create((currentField, data = {},) => {

    only(currentField)

    test('A1_CGC', 'El CUIT es requerido', () => {
        enforce(data.A1_CGC).isNotEmpty();
    });
    test('A1_CGC', 'El CUIT ingresado no es válido', () => {
        enforce(validarCuit(data.A1_CGC)).isTruthy();
    });

    test('A1_END', 'El campo Direccion es requerido', () => {
        enforce(data.A1_END).isNotEmpty();
    })
    test('A1_END', 'El campo Direccion debe tener máximo 40 caracteres', () => {
        enforce(data.A1_END).shorterThanOrEquals(40);
    });
    test('A1_NREDUZ', 'El campo Nombre Reduz es requerido', () => {
        enforce(data.A1_NREDUZ).isNotEmpty();
    });
    test('A1_NREDUZ', 'El campo Nombre Reduz debe tener máximo 20 caracteres', () => {
        enforce(data.A1_NREDUZ).shorterThanOrEquals(20);
    });

})
